import React, { useState, useEffect } from 'react'
import MainLayout from 'layouts/main'
import { useFlagcardContext } from 'app/contexts/flagcard'
import { getCountryPerceptions } from '../../../services/http/backoffice/country-perception/endpoints'
import backofficeDefinitionService from 'services/http/backoffice/definition/'

import { CreateVkResponse } from './../../../services/http/backoffice/definition/types'

import Page from '@zera-admin/page'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import { Column, Row, PageHeader } from '@zera-admin/page'
import Button from '@zera-admin/button'
import Checkbox from '@zera-admin/checkbox'
import Input from '@zera-admin/input'
import DateTimePicker from '@zera-admin/datetime-picker'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { RadioGroup } from '@zera-admin/radio'
import Icon from '@zera-admin/icon'
import Form, {
  useForm,
  FormHookSubmitProps,
  FormHeader,
  FormFooter,
  FormSection,
} from '@zera-admin/form'
const Vk = () => {
  const [formValues, setFormValues] = useState<{
    countryPerceptions: Array<SelectOptionProps>
  }>({
    countryPerceptions: [],
  })
  const [blackListWord, setBlackListWord] = useState<string>('')
  const [flagcard] = useFlagcardContext()

  useEffect(() => {
    getCountryPerceptions()
      .then((res) => res.data.data)
      .then((res) =>
        setFormValues((state) => ({
          ...state,
          countryPerceptions: res.map((country: any) => {
            return { label: country?.description, value: country?.key }
          }),
        }))
      )
  }, [])

  const initialValues: CreateVkResponse = {
    crawlingType: 'fetch',
    definitionType: 'keyword',
    definitionValue: '',
    countryPerception: 1,
    allowedLanguages: undefined,
    allowedDbs: undefined,
    useIncomingDefinition: false,
    environment: 'Alice',
    definitionBlackLists: undefined,
    periodicFetch: false,
    period: undefined,
    startTime: undefined,
    endTime: undefined,
  }

  const form = useForm<CreateVkResponse>({
    initialValues,
    onSubmit: (props) => handlerSubmit(props),
  })

  const handleAddBlackListWord = () => {
    if (blackListWord) {
      form.handleFieldChange('definitionBlackLists', [
        ...(form.values.definitionBlackLists || []),
        blackListWord,
      ])
      setBlackListWord('')
    }
  }

  const handleRemoveBlackListWord = (index: number) => {
    form.handleFieldChange(
      'definitionBlackLists',
      form.values.definitionBlackLists?.filter((_, i) => i !== index)
    )
  }

  const handlerSubmit = (props: FormHookSubmitProps<CreateVkResponse>) => {
    console.log(form.values)
    if (!props.errors) {
      if (form.values) {
        backofficeDefinitionService
          .createVk(form.values)
          .then(() => {
            flagcard.add({
              appearance: 'success',
              title: 'Kayıt işlemi başarılı',
              children:
                'Girmiş olduğunuz bilgiler ile birlikte veri sisteme başarıyla kayıt edilmiştir. Dilerseniz yeni veri ekleyebilirsiniz.',
            })
            form.handleBatchUpdate(initialValues)
          })
          .catch((error) => {
            console.log(error)
            flagcard.add({
              appearance: 'error',
              title: 'Bir hata oluştu',
              children:
                'Veri eklenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
      }
    }
  }

  const renderPageContent = () => {
    return (
      <React.Fragment>
        <Form onSubmit={handlerSubmit}>
          <FormHeader
            title="Vk Tanımlama Formu"
            description={
              <div style={{ marginBottom: '1.5rem' }}>
                <p>Form üzerinden aşağıdaki genel bilgileri doldurunuz.</p>
                <p style={{ margin: '0', color: '#A73121' }}>
                  Doldurulması zorunlu alanlar (*) işareti ile belirtilmiştir.
                </p>
              </div>
            }
          />
          <FormSection>
            <Row>
              <Column md={{ size: 3 }}>
                <RadioGroup
                  label="*CrawlingType"
                  name="crawlingType"
                  isRequired
                  options={[{ label: 'Fetch', value: 'fetch' }]}
                  value={form.values.crawlingType}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'crawlingType',
                      e.currentTarget.value
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column md={{ size: 3 }}>
                <RadioGroup
                  label="*Definition Type"
                  name="definitionType"
                  isRequired
                  options={[{ label: 'Keyword', value: 'keyword' }]}
                  value={form.values.definitionType}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'definitionType',
                      e.currentTarget.value
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                <Input
                  label="*Definition Value"
                  name="definitionValue"
                  isRequired
                  placeholder="Takip edilecek kelime giriniz."
                  value={form.values.definitionValue}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'definitionValue',
                      e.currentTarget.value
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Algı Seçiniz"
                  name="countryPerception"
                  options={formValues.countryPerceptions}
                  placeholder="Seçim yapın"
                  defaultValue={
                    formValues.countryPerceptions.find(
                      (country) => country.label === 'Türkiye'
                    ) || { label: 'Türkiye', value: 1 }
                  }
                  value={formValues.countryPerceptions.find(
                    (country) => country.value === form.values.countryPerception
                  )}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'countryPerception',
                      (e as SelectOptionProps).value
                    )
                  }}
                />
              </Column>
            </Row>
            {/* <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Dil Seçiniz"
                  name="allowedLanguages"
                  description="*İzin verilen diller listesi"
                  placeholder="Seçim Yapın"
                  isMultiple
                  options={[
                    { label: 'Turkish', value: 'Turkish' },
                    { label: 'English', value: 'English' },
                  ]}
                  value={form.values.allowedLanguages?.map((lang) => ({
                    label: lang,
                    value: lang,
                  }))}
                  onChange={(e) => {
                    const value = e as Array<SelectOptionProps>
                    form.handleFieldChange(
                      'allowedLanguages',
                      value.length > 0
                        ? value.map((lang) => lang.value)
                        : undefined
                    )
                  }}
                />
              </Column>
            </Row> */}
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Database Seçimi"
                  name="allowedDbs"
                  description="*Çekilen verilerin işlendikten sonra hangi db 'lere kaydedileceğini belirtir."
                  placeholder="Seçim Yapın"
                  isMultiple
                  options={[{ label: 'Oracle', value: 'oracle' }]}
                  value={form.values.allowedDbs?.map((db) => ({
                    label: db,
                    value: db,
                  }))}
                  onChange={(e) => {
                    const value = e as Array<SelectOptionProps>
                    form.handleFieldChange(
                      'allowedDbs',
                      value.length > 0 ? value.map((db) => db.value) : undefined
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} xl={{ size: 6 }}>
                <Checkbox
                  label="Bu definitiondan gelen postlar direkt olarak bu definition ile işaretlensin mi işaretlenmesin mi?"
                  name="useIncomingDefinition"
                  isChecked={form.values.useIncomingDefinition}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'useIncomingDefinition',
                      e.currentTarget.checked
                    )
                  }}
                />
              </Column>
            </Row>

            {/* <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Environment"
                  name="environment"
                  placeholder="Seçim Yapın"
                  options={[
                    { label: 'Alice', value: 'Alice' },

                  ]}
                  value={
                    form.values.environment
                      ? [
                          {
                            label: form.values.environment,
                            value: form.values.environment,
                          },
                        ]
                      : null
                  }
                  onChange={(e) => {
                    form.handleFieldChange(
                      'environment',
                      (e as SelectOptionProps).value
                    )
                  }}
                />
              </Column>
            </Row> */}
            <>
              <Row>
                <Column xs={{ size: 4 }}>
                  <Input
                    name="blackListWord"
                    label="Tanımlama Kara Listesi"
                    placeholder="Bir kara liste kelimesi giriniz"
                    description="Bir kara liste kelimesi giriniz"
                    value={blackListWord}
                    onChange={(props) => {
                      setBlackListWord(props.currentTarget.value)
                    }}
                  />
                </Column>
                <Column xs={{ size: 4 }}>
                  <Button
                    onClick={handleAddBlackListWord}
                    appearance="primary"
                    children="Ekle"
                    style={{ marginTop: '16px' }}
                  />
                </Column>
              </Row>
              {form.values.definitionBlackLists?.map((word, index) => (
                <Row key={index}>
                  <Column xs={{ size: 4 }}>{word}</Column>
                  <Column>
                    <Button
                      onClick={() => handleRemoveBlackListWord(index)}
                      appearance="error"
                      children="Kaldır"
                      style={{ marginTop: '16px' }}
                    />
                  </Column>
                </Row>
              ))}
            </>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <DateTimePicker
                  label="Başlangıç Tarihi Seçin"
                  description="*Belirtilen tarihten sonraki veriler çekilir."
                  placeholder="Seçim Yapın"
                  name="startTime"
                  type="date"
                  value={form.values.startTime?.toString()}
                  onChange={(e) => {
                    e
                      ? form.handleFieldChange(
                          'startTime',
                          new Date(e).toISOString()
                        )
                      : form.handleFieldChange('startTime', undefined)
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <DateTimePicker
                  label="Bitiş Tarihi Seçin"
                  description="*Belirtilen tarihten önceki veriler çekilir."
                  placeholder="Seçim Yapın"
                  name="endTime"
                  type="date"
                  value={form.values.endTime?.toString()}
                  onChange={(e) => {
                    e
                      ? form.handleFieldChange(
                          'endTime',
                          new Date(e).toISOString()
                        )
                      : form.handleFieldChange('endTime', undefined)
                  }}
                />
              </Column>
            </Row>

            <Row>
              <Column xs={{ size: 12 }} xl={{ size: 6 }}>
                <Checkbox
                  label="Periyodik olarak çekilsin mi ?"
                  name="periodicFetch"
                  isChecked={form.values.periodicFetch}
                  onChange={(e) => {
                    const value = e.currentTarget.checked
                    form.handleFieldChange('periodicFetch', value)
                  }}
                />
              </Column>
            </Row>
            {form.values.periodicFetch && (
              <Row>
                <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                  <Input
                    label="*Period"
                    name="period"
                    placeholder="Periyot giriniz (0 * * * *)"
                    description="Geçerli bir periyot giriniz"
                    isRequired={form.values.periodicFetch}
                    value={form.values.period}
                    onChange={(e) => {
                      const value = e.currentTarget.value
                      form.handleFieldChange(
                        'period',
                        value !== '' ? value : undefined
                      )
                    }}
                  />
                </Column>
              </Row>
            )}
          </FormSection>
          <FormFooter align="start">
            <Button
              appearance="primary"
              iconBefore={<Icon name="add-item" />}
              children="Tanımlama Oluştur"
              isDisabled={
                (form.values.periodicFetch && !form.values.period) ||
                form.values.definitionValue === ''
              }
              type="submit"
            />
          </FormFooter>
        </Form>
      </React.Fragment>
    )
  }

  return (
    <MainLayout>
      <Page>
        <PageHeader
          breadcrumbs={
            <Breadcrumb>
              <BreadcrumbItem text="Anasayfa" href="/" />
              <BreadcrumbItem text="Tanımlama" href="/definition" />
              <BreadcrumbItem
                text="Tanımlama oluştur"
                href="/definition/create"
              />
              <BreadcrumbItem text="Vk" />
            </Breadcrumb>
          }
        />

        {renderPageContent()}
      </Page>
    </MainLayout>
  )
}

export default Vk
